const SCROLL_KEYS = new Set(["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "]);

const TEXT_FIELDS = "input, textarea, select, [contenteditable]";

// A text field uses these keys itself, and Space presses a focused button (the
// switch) rather than scrolling.
const usesKeyItself = ({ key, target }) =>
  !!target?.closest?.(key === " " ? `${TEXT_FIELDS}, button` : TEXT_FIELDS);

const LISTENER_OPTIONS = { passive: false };

/**
 * Holds the page at its scroll position until `release`: the wheel, touch and
 * scroll keys are cancelled, and anything else that moves it (dragging the
 * scrollbar) is put back. No `overflow: hidden`, which would drop the scrollbar
 * and shift the layout under the animation.
 *
 * Scrolling by code is the caller's own: call `holdHere` after it to hold the
 * page at the new position.
 *
 * Each lock has its own listeners: the browser would treat shared ones as
 * duplicates, and releasing an older lock (a sweep a newer one replaced) would
 * then unlock the newer one.
 *
 * @returns {{ holdHere: () => void, release: () => void }}
 */
export const lockScroll = () => {
  let heldY = window.scrollY;
  const cancel = (event) => event.preventDefault();
  const cancelScrollKey = (event) => {
    if (SCROLL_KEYS.has(event.key) && !usesKeyItself(event)) event.preventDefault();
  };
  const putBack = () => {
    if (window.scrollY !== heldY) window.scrollTo(window.scrollX, heldY);
  };

  window.addEventListener("wheel", cancel, LISTENER_OPTIONS);
  window.addEventListener("touchmove", cancel, LISTENER_OPTIONS);
  window.addEventListener("keydown", cancelScrollKey);
  window.addEventListener("scroll", putBack);

  return {
    holdHere: () => {
      heldY = window.scrollY;
    },
    release: () => {
      window.removeEventListener("wheel", cancel, LISTENER_OPTIONS);
      window.removeEventListener("touchmove", cancel, LISTENER_OPTIONS);
      window.removeEventListener("keydown", cancelScrollKey);
      window.removeEventListener("scroll", putBack);
    },
  };
};
